angular.module('impactx.panel').controller('CatalogPreviewPanelCtrl', [
    '$scope',
    'ImageEditor',
    'TranslationService',
    CatalogPreviewPanelCtrl]);

function CatalogPreviewPanelCtrl($scope, ImageEditor, TranslationService) {
    var self = this;
    if(!self.trns) {
        self.trns = {};
    }
    self.externalCatalogTrns = TranslationService.get('externalCatalog');

    self.deleteImage = function(event) {
        if(event) {
            event.stopPropagation();
            event.preventDefault();
        }
        self.image.isDeleted = true;
        self.image.file = undefined;
        self.image.url = "img/missing-image.jpg";
    };

    self.openEditor = function (event, currentImage, newImage) {
        ImageEditor.open(event, currentImage, newImage, 'square').then(function (croppedImage) {
            if(!croppedImage) {
                return
            } if(!croppedImage.image) {
                self.deleteImage(event);
            } else {
                self.image.file = croppedImage.image;
                self.image.fileName = croppedImage.name;
                self.image.isDeleted = true;
            }
        })
    };

    $scope.$watch(function() {
        return impactX.isDefined(self, "image.file");
    }, function(newValue, oldValue) {
        if(newValue && !angular.equals(newValue, oldValue)) {
            self.image.isDeleted = true;
        }
    });
}